import { useParams, useLocation } from "react-router-dom";
import ListViewLayout from "../layout/ListViewLayout";

function ListView() {
  const { objectName } = useParams();
  const location = useLocation();
  console.log("Object Edit Wrapper-->", objectName);
  console.log("ListView URL parameters:", location.search);
  return <ListViewLayout objectName={objectName} location={location} />;
}
export default ListView;
